import { render, staticRenderFns } from "./PriorIncomeSection.vue?vue&type=template&id=615a721e&scoped=true"
import script from "./PriorIncomeSection.vue?vue&type=script&lang=js"
export * from "./PriorIncomeSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615a721e",
  null
  
)

export default component.exports